import React from 'react'
import cn from 'clsx'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { rem } from 'polished'
import { accountAccessShowLogin } from 'actions/UiActions'
import SocialButtons from 'components/Account/AccountAccess/AccountAccessSocialButtons'
import { mediaQueryUp } from 'components/utils/breakpoint'
import SocialStars from 'components/Common/SocialStars/SocialStars'
import TextButton from 'LuxKit/Button/TextButton'
import TextLink from 'LuxKit/TextLink'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const ButtonsBlock = styled.div`
  padding: 0 ${rem(20)};
`

const Wrapper = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  padding: ${rem(30)} ${rem(25)} ${rem(25)};

  ${mediaQueryUp.desktop} {
    margin-left: auto;
    max-width: ${rem(360)};

    // bandaid fix for centering hub page modal until design & marketing update
    &.hub {
      margin: auto;
    }
  }
`

interface Props {
  title: string
  prefix?: string
  className?: string
  accountAccessShowLogin: () => void
  isStoreMode: boolean
  version?: string
}

function SignUpBox(props: Props) {
  if (props.isStoreMode) {
    return null
  }

  return <Wrapper className={cn(props.className, props.version)}>
    <Heading variant="heading5" align="center">
      Get exclusive offers to amazing destinations
    </Heading>

    <VerticalSpacer gap={24}>
      <SocialStars prefix={props.prefix} />
      <ButtonsBlock>
        <VerticalSpacer gap={12}>
          <SocialButtons mode="join" hideText inline />
          <TextButton
            kind="primary"
            onClick={() => props.accountAccessShowLogin()}
            fit="flex"
          >
            Sign up with email
          </TextButton>
          <BodyText variant="large" align="center">
            Already have an account? {' '}
            <TextLink onClick={() => props.accountAccessShowLogin()}>
              Log in
            </TextLink>
          </BodyText>
        </VerticalSpacer>
      </ButtonsBlock>
    </VerticalSpacer>
  </Wrapper>
}

function mapStateToProps(state: App.State) {
  return {
    isStoreMode: state.system.storeMode,
  }
}

const mapDispatchToProps = {
  accountAccessShowLogin,
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpBox)
